<template>
  <div>
    <mf-search
      v-model="searchValue"
      class="search-bar"
      :placeholder="placeholder"
      :loading="loading"
      @input="automaticQuery"
      @keyup.enter="forcedQuery"
      @blur="hideList"
      @focus="showList = true"
    />

    <v-list v-if="showList && searchedItems.length" class="elevation-1 results light-background">
      <v-list-item v-for="(item, searchIndex) in searchedItems" :key="searchIndex" @click="redirectItem(item[configs[searchType].idProperty])">
        <v-list-item-content>
          <span class="body-1">{{ item[configs[searchType].idProperty] }} - {{ item[configs[searchType].descriptionProperty] }}</span>
        </v-list-item-content>
        <v-list-item-action>
          <mf-icon>chevron_right</mf-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import { assertArray } from '@/config/helpers.js'
import gql from 'graphql-tag'
export const QUERY_PRODUCTS = gql`
  query Products($search: String) {
    products(search: $search) {
      products {
        _id
        sku
        name
      }
    }
  }
`

export default {
  props: {
    searchType: String,
  },
  data: () => ({
    loading: false,
    showList: false,
    searchedItems: [],
    searchValue: null,
    configs: {
      cliente: {
        actionName: 'buscaClientes',
        idProperty: 'COD_ID_CLIENTE_SEARCH',
        descriptionProperty: 'NOM_NOME_SEARCH',
      },
      produto: {
        idProperty: 'sku',
        descriptionProperty: 'name',
      },
    },
  }),
  computed: {
    placeholder() {
      return this.searchType === 'cliente' ? 'Buscar clientes' : 'Buscar produtos'
    },
  },
  methods: {
    forcedQuery(response) {
      this.querySelections(response.target.value)
    },
    automaticQuery(query) {
      if (query.length < 3) {
        this.searchedItems = []
        return
      }
      this.querySelections(query)
    },
    querySelections(query) {
      this.loading = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (this.searchType === 'produto') {
          this.$apollo
            .query({
              query: QUERY_PRODUCTS,
              variables: {
                search: this.searchValue,
              },
              fetchPolicy: 'no-cache',
            })
            .then(({ data: { products } }) => {
              this.searchedItems = products.products
              this.loading = false
            })
        } else if (this.searchType === 'cliente') {
          this.$store
            .dispatch(this.configs[this.searchType].actionName, {
              cliente: query,
              cpf_cnpj: query,
            })
            .then((response) => {
              this.searchedItems = orderBy(assertArray(response.data), this.configs[this.searchType].descriptionProperty, 'asc')
              this.loading = false
            })
        }
      }, 500)
    },
    async redirectItem(param) {
      await this.$router.push({ path: `/${this.searchType}s/detalhes-${this.searchType}/${param}` }).catch(() => {})
      this.$bus.$emit('search')
    },
    hideList() {
      setTimeout(() => {
        this.showList = false
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.search-bar {
  position: relative;
  top: 24px;
}
.results {
  max-height: 400px;
  overflow-y: auto;
}
</style>
